import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmDialog } from '@playbookux/playbook-web-core';

const WARNING_MESSAGE = 'Warning: This cannot be undone';

const ModalDelete = (props) => {
  const {
    onConfirm,
    errorMessage,
    loading,
    show,
    title,
    confirmText,
    cancelText,
    onClose,
  } = props;

  return (
    <ConfirmDialog
      show={show}
      title={title}
      warning={WARNING_MESSAGE}
      confirmText={confirmText}
      cancelText={cancelText}
      handleClose={onClose}
      handleConfirm={onConfirm}
      errorMessage={errorMessage}
      loading={loading}
    />
  );
};

ModalDelete.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
};

export default ModalDelete;
